"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var pickers_1 = require("@material-ui/pickers");
var react_1 = require("react");
var components_1 = require("../../../common/components");
var breadcrumbUtil_1 = require("../../../common/breadcrumbUtil");
var dateUtils_1 = require("../../../youwell-common/dateUtils");
var image_1 = require("../../../common/image");
var ActivityTable_1 = __importDefault(require("./components/ActivityTable"));
var AddEditActivityDialog_1 = __importDefault(require("./components/AddEditActivityDialog"));
var DateDetails_1 = __importDefault(require("./components/DateDetails"));
var objectUtils_1 = require("../../../youwell-common/objectUtils");
var ActivityList_1 = __importDefault(require("./components/ActivityList"));
var arrayUtils_1 = require("../../../youwell-common/arrayUtils");
var constants_1 = require("../../../common/constants");
var activityService_1 = require("../../../app/services/activityService");
var translate_1 = __importDefault(require("../../../app/localization/translate"));
var store_1 = require("../../../app/store");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e, _f;
    return (0, core_1.createStyles)({
        top: (_a = {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                marginBottom: theme.spacing(4)
            },
            _a[theme.breakpoints.down('md')] = {
                padding: theme.spacing(3, 3),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(1, 0),
            },
            _a),
        sectionTitle: {
            borderLeft: theme.youwell.borders.secondary,
            marginBottom: theme.spacing(3),
            padding: theme.spacing(1, 2),
        },
        tabs: {
            padding: theme.spacing(1, 2),
        },
        followUpActivitiesTableContainer: (_b = {
                backgroundColor: theme.palette.background.default,
                padding: theme.spacing(5, 4),
                borderRadius: theme.youwell.shapes.borderRadiusRounder,
                width: '100%'
            },
            _b[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(2, 2),
            },
            _b[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2, 1),
            },
            _b),
        flexContainer: {
            display: 'flex',
            alignItems: 'flex-start',
        },
        followUpActivitiesTable: {
            flex: '1 1 auto',
        },
        effortDescription: {
            display: 'flex',
            alignItems: 'center',
        },
        flagIcon: (_c = {
                margin: theme.spacing(4, 5, 0, 5)
            },
            _c[theme.breakpoints.down('sm')] = {
                display: 'none',
            },
            _c),
        flagIconSmall: (_d = {
                margin: theme.spacing(0, 1)
            },
            _d[theme.breakpoints.up('md')] = {
                display: 'none',
            },
            _d),
        content: (_e = {
                padding: theme.spacing(4, 10),
                marginBottom: theme.spacing(4),
                '&:last-child': {
                    marginBottom: theme.spacing(12),
                }
            },
            _e[theme.breakpoints.down('md')] = {
                padding: theme.spacing(3, 3),
            },
            _e[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(1, 0),
            },
            _e),
        calendar: {
            background: theme.palette.common.white,
            borderRadius: theme.youwell.shapes.borderRadiusRounder,
            width: '100%',
            minHeight: 340,
            overflowX: 'hidden',
        },
        day: {
            width: 36,
            height: 36,
            margin: 2,
            fontSize: theme.typography.caption.fontSize,
            borderRadius: theme.youwell.shapes.borderRadius,
            color: 'inherit',
            '&:hover': {
                color: theme.palette.common.white,
                background: theme.palette.primary.light,
            },
        },
        notCompleted: {
            background: 'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' version=\'1.1\' preserveAspectRatio=\'none\' viewBox=\'0 0 100 100\'><path d=\'M0 99 L99 0 L100 1 L1 100\' fill=\'red\' /></svg>")',
            backgroundColor: "".concat(theme.palette.secondary.main, "aa"),
            color: theme.palette.common.white,
        },
        notRegistered: {
            background: theme.palette.grey[200],
        },
        completed: {
            background: theme.palette.secondary.main,
            color: theme.palette.common.white,
        },
        today: {
            fontWeight: theme.typography.fontWeightBold,
            border: theme.youwell.borders.primary,
        },
        futurePlans: {
            background: theme.palette.secondary.dark,
            color: theme.palette.common.white,
        },
        nonCurrentMonthDay: {
            background: theme.palette.common.white,
            color: theme.palette.text.disabled,
        },
        noActivityRegistered: (_f = {
                padding: theme.spacing(3),
                textAlign: 'center'
            },
            _f[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(2),
            },
            _f),
        addActivityModal: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    });
}, { name: 'ActivityDiary' });
var getActivityLookup = function (activities) { return (activities === null || activities === void 0 ? void 0 : activities.reduce(function (prev, activity) {
    var _a;
    var future = (0, dateUtils_1.isFuture)(activity.date);
    return __assign(__assign({}, prev), (_a = {}, _a[(0, dateUtils_1.isoDate)(activity.date)] = {
        entry: activity,
        future: future,
        notCompleted: activity.effortRating === -1,
        notRegistered: !activity.effortRating,
        completed: activity.effortRating && activity.effortRating > 0,
    }, _a));
}, {})) || {}; };
var ActivityDiary = function () {
    var classes = useStyles();
    var dispatch = (0, react_redux_1.useDispatch)();
    var translate = (0, translate_1.default)();
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var patientId = (0, store_1.useYouwellSelector)(function (state) { return state.auth.profileData && state.auth.profileData.id; });
    var activities = (0, store_1.useYouwellSelector)(function (state) { return state.activityDataStore.activities; }); // TODO: add || [] in the end? does not work... entries will not load then..
    var activitiesLoadedFrom = (0, store_1.useYouwellSelector)(function (state) { return state.activityDataStore.activitiesLoadedFrom; });
    var _a = React.useState(null), activitiesToFollowUp = _a[0], setActivitiesToFolluwUp = _a[1];
    var _b = React.useState({}), followupHashset = _b[0], setFollowupHashset = _b[1];
    var _c = React.useState(true), showUpcoming = _c[0], setShowUpcoming = _c[1];
    var _d = React.useState(null), addEditActivity = _d[0], setAddEditActivity = _d[1];
    var _e = React.useState(null), selectedDate = _e[0], setSelectedDate = _e[1];
    (0, react_1.useEffect)(function () {
        if (!activities && patientId) {
            (0, activityService_1.fetchActivitiesData)(dispatch);
        }
    }, [dispatch, patientId, activities]);
    var todayDate = React.useMemo(function () { return (0, dateUtils_1.today)(); }, []);
    (0, react_1.useEffect)(function () {
        // Using hashset to set isRated on elements. For fade out visualization after registration of effort
        if (activities && activities.length > 0) {
            var newActivitiesToFollowUp = activities === null || activities === void 0 ? void 0 : activities.filter(function (d) {
                var ld = (0, dateUtils_1.getLocalDate)(d.date);
                return ld !== null && todayDate >= ld && (!d.effortRating || (followupHashset && d.id && followupHashset[d.id]));
            }).map(function (d) { return (__assign(__assign({}, d), { isRated: (0, objectUtils_1.hasValue)(d.effortRating) && (followupHashset && d.id && followupHashset[d.id]) })); });
            var newLookup = newActivitiesToFollowUp.reduce(function (prev, curr) {
                var _a;
                return (curr.id ? __assign(__assign({}, prev), (_a = {}, _a[curr.id.toString()] = true, _a)) : __assign({}, prev));
            }, followupHashset);
            setActivitiesToFolluwUp(newActivitiesToFollowUp);
            setFollowupHashset(newLookup);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activities, todayDate]); // dont depend on followupHashset-changes.
    var dateLookup = React.useMemo(function () { return (activities && activities.length > 0 ? getActivityLookup(activities) : {}); }, [activities]);
    var upcomingActivities = React.useMemo(function () { return (activities && activities.length > 0 ? activities.filter(function (activity) { var _a; return dateLookup && ((_a = dateLookup[(0, dateUtils_1.isoDate)(activity.date)]) === null || _a === void 0 ? void 0 : _a.future); }) : []); }, [activities, dateLookup]);
    var pastActivities = React.useMemo(function () { return (activities && activities.length > 0 ? activities.filter(function (activity) { var _a; return dateLookup && !((_a = dateLookup[(0, dateUtils_1.isoDate)(activity.date)]) === null || _a === void 0 ? void 0 : _a.future); }) : []); }, [activities, dateLookup]);
    var onClickDate = function (date) {
        if (!date) {
            return;
        }
        var dateWithoutTime = new Date(date);
        dateWithoutTime.setHours(0, 0, 0, 0);
        var activitiesOnSelectedDate = activities === null || activities === void 0 ? void 0 : activities.filter(function (a) { return (0, dateUtils_1.isSameDate)(a.date, dateWithoutTime); });
        if (activitiesOnSelectedDate && activitiesOnSelectedDate.length > 0) {
            setSelectedDate(dateWithoutTime);
        }
        else {
            setAddEditActivity({ date: dateWithoutTime, category: constants_1.activityCategories.physical });
        }
    };
    var renderCalendarDay = function (date, _selected, dayInCurrentMonth) {
        var _a;
        var dayClassName;
        if (dateLookup) {
            var d = dateLookup[(0, dateUtils_1.isoDate)(date)] || {};
            dayClassName = (0, classnames_1.default)(classes.day, (_a = {},
                _a[classes.today] = (0, dateUtils_1.isSameDate)(date, todayDate),
                _a[classes.nonCurrentMonthDay] = !dayInCurrentMonth,
                _a[classes.notCompleted] = !d.future && d.notCompleted,
                _a[classes.notRegistered] = !d.future && d.notRegistered,
                _a[classes.completed] = d.completed,
                _a[classes.futurePlans] = d.future,
                _a));
        }
        return (React.createElement(core_1.ButtonBase, { className: dayClassName, disabled: !dayInCurrentMonth },
            React.createElement("span", null, dayInCurrentMonth && date ? date.getDate() : '')));
    };
    var loadMonth = function (date) {
        var d = (0, dateUtils_1.getLocalDate)(activitiesLoadedFrom);
        if (d !== null && date !== null && date < d) {
            (0, activityService_1.fetchActivitiesData)(dispatch, {
                start: (0, dateUtils_1.addDays)(date, -30),
                end: activitiesLoadedFrom,
            });
        }
    };
    var hasActivitiesToFollowUp = Boolean((activitiesToFollowUp === null || activitiesToFollowUp === void 0 ? void 0 : activitiesToFollowUp.length) && activitiesToFollowUp.length > 0);
    return (React.createElement(components_1.PageLayout, { breadcrumb: (0, breadcrumbUtil_1.getBreadCrumb)(translate('activityDiary.header'), translate, clientConfig) },
        hasActivitiesToFollowUp && (React.createElement("div", { className: classes.top },
            React.createElement("div", { className: classes.sectionTitle },
                React.createElement(core_1.Typography, { variant: "h6" }, translate('activityDiary.activities'))),
            React.createElement("div", { className: classes.followUpActivitiesTableContainer },
                React.createElement(core_1.Typography, { variant: "subtitle1", className: classes.effortDescription },
                    React.createElement("div", { className: classes.flagIconSmall },
                        React.createElement(image_1.FlagIcon, null)),
                    translate('activityDiary.registerYourEffort')),
                React.createElement("div", { className: classes.flexContainer },
                    React.createElement("div", { className: classes.flagIcon },
                        React.createElement(image_1.FlagIcon, null)),
                    React.createElement("div", { className: classes.followUpActivitiesTable },
                        React.createElement(ActivityTable_1.default, { data: activitiesToFollowUp, onEditClick: function (activity) { return setAddEditActivity(activity); }, showRating: true })))))),
        React.createElement("div", { className: classes.content },
            React.createElement("div", { className: classes.sectionTitle },
                React.createElement(core_1.Typography, { variant: "h6" }, translate('activityDiary.calendar')),
                React.createElement(core_1.Typography, { variant: "subtitle1" }, translate('activityDiary.calendarInfo'))),
            React.createElement("div", { className: classes.calendar },
                React.createElement(pickers_1.Calendar, { onMonthChange: loadMonth, date: todayDate, onChange: onClickDate, renderDay: renderCalendarDay, allowKeyboardControl: false }))),
        React.createElement(core_1.Tabs, { className: classes.tabs, value: showUpcoming ? 0 : 1, onChange: function (event, value) { return setShowUpcoming(value === 0); }, variant: "fullWidth" },
            React.createElement(core_1.Tab, { label: translate('activityDiary.upcoming'), value: 0 }),
            React.createElement(core_1.Tab, { label: translate('activityDiary.pastActivities'), value: 1 })),
        showUpcoming ? (React.createElement("div", { className: classes.content }, upcomingActivities && upcomingActivities.length > 0 ? (React.createElement(ActivityList_1.default, { data: upcomingActivities, onEditClick: function (activity) { return setAddEditActivity(activity); } }))
            : (React.createElement(core_1.Typography, { className: classes.noActivityRegistered, variant: "subtitle1", color: "textSecondary" }, translate('activityDiary.noActivitiesRegistered'))))) : (React.createElement("div", { className: classes.content }, pastActivities && pastActivities.length > 0 ? (React.createElement(ActivityList_1.default, { data: (0, arrayUtils_1.reverse)(pastActivities), onEditClick: function (activity) { return setAddEditActivity(activity); }, showRating: true }))
            : (React.createElement(core_1.Typography, { className: classes.noActivityRegistered, variant: "subtitle1", color: "textSecondary" }, translate('activityDiary.noActivitiesRegistered'))))),
        React.createElement(DateDetails_1.default, { open: Boolean(selectedDate), onClose: function () { return setSelectedDate(null); }, onAddClick: function (date) { return setAddEditActivity({ date: date }); }, onEditClick: function (activity) { return setAddEditActivity(activity); }, date: selectedDate }),
        React.createElement(core_1.Modal, { open: Boolean(addEditActivity), onClose: function () { return setAddEditActivity(null); }, className: classes.addActivityModal },
            React.createElement("div", null, addEditActivity && (React.createElement(AddEditActivityDialog_1.default, { onClose: function () { return setAddEditActivity(null); }, activity: addEditActivity }))))));
};
exports.default = ActivityDiary;
